module.exports = __webpack_public_path__ + "img/guide.4030b311.jpg";